import React from "react";
import { InputNumber } from "antd";
import { InputNumberProps } from "antd/lib/input-number";

/**
 * Pre-configured Price Input Component
 * @param props  Component Props
 */
const PriceInput = (props: InputNumberProps) => {
  const handleChange = (value: any) => {
    if (props.onChange) {
      props.onChange(value);
    }
  };

  return (
    <InputNumber
      onChange={handleChange}
      min={0}
      formatter={(value) => `$${value}`}
      placeholder="$0.00"
      step={0.1}
      precision={2}
      {...props}
    />
  );
};

export { PriceInput };
